import Vue from 'vue';
import { conditonJudgment } from '@/utils/condition';
import input from './input.vue';
import checkbox from './checkbox.vue';
import datetime from './datetime.vue';
import member from './member';
import dep from './dep';
import radio from './radio';
import accessory from './accessory.vue';
import richText from './richText.vue';
import region from './region.vue';
import number from './number.vue';
import associationTable from './associationTable';
import associationField from './associationField.vue';
import cascadeSelect from './cascadeSelect1.vue';
import timeLimit from './timeLimit.vue';
import statistics from './statistics.vue';
import childTable from './childTable.vue';
import dynamicTable from './dynamicTable.vue';
import externalComponent from './externalControl'
import stepBar from './stepsArticle.vue'
let defaultArr = ['associationTable', 'checkbox', 'accessory', 'region'];
let widget = {
  text: input,
  phone: input,
  email: input,
  number: number,
  autoNumber: input,
  richText,
  checkbox,
  radio,
  datetime,
  region,
  member,
  department: dep,
  accessory,
  associationTable,
  associationField,
  cascadeSelect,
  timeLimit,
  statistics,
  childTable,
  dynamicTable,
  externalComponent,
  stepBar,
  cuttingLine: {
    props: {
      item: Object
    },
    render: function (h) {
      let vm = this;
      return h('div', { class: { 'field-cuttingLine': true } }, vm.item.name);
    }
  },
  remark: {
    props: {
      item: Object
    },
    render($h) {
      let vm = this;
      return $h('div', {
        class: {
          'field-mark': true
        },
        domProps: {
          innerHTML: vm.item.remarkContent
        }
      });
    }
  },
};
export default {
  functional: true,
  props: {
    item: {
      type: Object,
      required: true
    },
    useFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    form: Object
  },
  render: function (createElement, context) {
    let useFilter = context.props.useFilter;
    let { filters = [] } = context.props.item;
    let form = context.props.form;
    let isShow = (useFilter && conditonJudgment(filters, form)) || !useFilter;
    let type = context.props.item.fieldType;
    if (isShow) {
      return createElement(
        widget[type],
        { ...context.data, props: context.props },
      );
    } else {
      return '';
    }
  }
};